import { useQuery } from "@tanstack/react-query";
import { ListPlansQueryFilters, UseListPlansQueryOptions } from "./types";
import { getPlansService } from "./service";

export const listPlansQueryKey = ["subscription_plan_admin"];

export function useListPlansQuery(
  filters?: ListPlansQueryFilters,
  options?: UseListPlansQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listPlansQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getPlansService(filters),
    ...options,
  });
}
